import tracking from '../../utils/tracking';

export default class GuidedSidebar {
  stickyPosition: number;
  domRoot: HTMLElement;
  sections: HTMLCollectionOf<Element>;
  sideLinks: HTMLCollectionOf<Element>;
  scrollDisabled: boolean;
  isScrolling: boolean;
  isAgile: any;
  activeLink: any;
  activeSection: any;
  observerConfig: { root: null; rootMargin: string; threshold: number; };
  observer: IntersectionObserver;

  constructor(domRoot: HTMLElement, params: any) {
    this.stickyPosition = Number(params.stickyPosition);
    this.domRoot = domRoot;
    this.sections = document.getElementsByClassName('guided-sidebar-block');
    this.sideLinks = document.getElementsByClassName("guide-sidebar-child-link");
    this.scrollDisabled = false;
    this.isAgile = params.isAgile;
    this.activeLink;
    this.activeSection = this.sections[0] ? this.sections[0].id : "";
    this.observerConfig = {
      root: null,
      rootMargin: '0px',
      threshold: 0.25
    };
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.intersectionRatio >= 0.25 && !this.scrollDisabled) {
          let newActive = entry.target.id;
          this.activeSection = newActive;
          history.replaceState(null, null, "#" + newActive);
          this.renderSideBar();
        }
      });
    }, this.observerConfig);
    this.init();
  }

  init() {
    for (var s = 0; s < this.sideLinks.length; s++) {
      if (this.sideLinks[s].getAttribute("href") == window.location.pathname) {
        this.sideLinks[s].classList.add("active");
        this.activeLink = this.sideLinks[s].parentNode;
      }
    }
    const firstLinks = this.domRoot.querySelectorAll(".level1");

    firstLinks.forEach(firstLink => {

      firstLink.addEventListener("click", (e) => {

        if ((e.target.nextElementSibling && e.target.nextElementSibling.classList.contains("nested-links"))) {
          e.preventDefault();

          firstLinks.forEach(fLink => {
            if (e.target != fLink) {
              fLink.parentNode.classList.remove("revealed");
            }
          });
          e.target.parentNode.classList.toggle("revealed");
        }
      })
    });

    this.renderSideBar();
    if (this.activeLink) {
      window.scrollTo(0, window.scrollY - 100);
    }

    window.addEventListener("scroll", () => {
      this.positionSidebar();
    });

    const countrySpecificBlock = document.querySelector('.country-specific-block');
    if (countrySpecificBlock) {
      document.addEventListener('country-specific-block-display-rendered', () => {
        this.setObservables();
      });
    } else {
      this.setObservables();
    }
  }

  scrollToElementOffset(element){
    element.scrollIntoView();
    window.scrollTo(0, window.scrollY - 80);
  }

  renderSideBar() {
    var oldSubs = document.getElementById('guide-subs');
    if (oldSubs) {
      oldSubs.parentNode?.removeChild(oldSubs);
    }
    var subLinks = document.createElement('div');
    subLinks.className = "sub-links";
    subLinks.id = 'guide-subs';
    for (var b = 0; b < this.sections.length; b++) {
      var subLink = document.createElement('a');
      subLink.className = "sub-link";
      subLink.onclick = (e) => {
        const blockID = e.target.getAttribute("href");
        this.scrollDisabled = true;
        e.preventDefault();
        window.location.hash = blockID;
        this.scrollToElementOffset(document.querySelector(blockID));
        this.activeSection = blockID.replace("#", "");
        tracking.trackEvent('clicked', {
          label: e.target.innerText
        });
        this.renderSideBar();
        setTimeout(() => {
          this.scrollDisabled = false;
        }, 1000);
      };
      subLink.setAttribute("href", "#" + this.sections[b].id);
      if (this.activeSection == this.sections[b].id) {
        subLink.className = "sub-link active";
      }
      if (this.sections[b].hasAttribute('data-sidebar-title')) {
        subLink.innerHTML = this.sections[b].getAttribute('data-sidebar-title');
      } else {
        subLink.innerHTML = this.sections[b].getAttribute('data-title');
      }
      subLinks.appendChild(subLink);
    }
    if (this.activeLink) {
      this.activeLink.appendChild(subLinks);
    }
  }

  positionSidebar() {
    let winTop = window.scrollY;
    let winBot = window.innerHeight;
    let guideStyle = this.domRoot.style;
    let guideHeight = this.domRoot.offsetHeight;

    let parentContainer = this.domRoot.parentNode?.parentNode as HTMLElement;
    let sidebarOffset = this.offsetTopFind(parentContainer.parentNode as HTMLElement);
    let parentHeight = this.offsetTopFind(parentContainer, parentContainer.offsetHeight);
    let bottomPos = winTop - parentHeight + winBot;

    if (winTop >= (sidebarOffset - this.stickyPosition)) {
      guideStyle.position = "fixed";
      guideStyle.maxHeight = "calc(100% - " + this.stickyPosition + "px)";
      guideStyle.width = ((this.domRoot.parentNode as HTMLElement).offsetWidth - 32) + "px";
      if (winTop > (parentHeight - guideHeight - this.stickyPosition)) {
        guideStyle.bottom = bottomPos + "px";
        guideStyle.top = "auto";
      } else {
        guideStyle.top = this.stickyPosition + "px";
        guideStyle.bottom = "auto";
      }
    } else {
      guideStyle.position = "static";
      guideStyle.top = "auto";
      guideStyle.bottom = "auto";
      guideStyle.width = "auto";
    }
  }

  offsetTopFind(el: HTMLElement, withHeight = 0) {
    var yPosition = withHeight;
    while (el.parentNode !== null) {
      yPosition += el.offsetTop;
      el = el.parentNode as HTMLElement;
    }
    return yPosition;
  }

  setObservables() {
    for (var s = 0; s < this.sections.length; s++) {
      this.observer.observe(this.sections[s]);
    }
  }
}
